import { render, staticRenderFns } from "./foot-button.vue?vue&type=template&id=ea1058ae&scoped=true&"
import script from "./foot-button.vue?vue&type=script&lang=js&"
export * from "./foot-button.vue?vue&type=script&lang=js&"
import style0 from "./foot-button.vue?vue&type=style&index=0&id=ea1058ae&prod&scoped=true&lang=less&"
import style1 from "./foot-button.vue?vue&type=style&index=1&id=ea1058ae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1058ae",
  null
  
)

export default component.exports